module.exports = __webpack_public_path__ + "img/favicon-src.cb1ca8e1d6899be439f7ddba87fff5b9.png";